var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_982_5274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9166 20.7917C22.9166 21.3442 22.6972 21.8741 22.3065 22.2648C21.9158 22.6555 21.3858 22.875 20.8333 22.875L4.16665 22.875C3.61411 22.875 3.08421 22.6555 2.69351 22.2648C2.30281 21.8741 2.08331 21.3442 2.08331 20.7917L2.08331 6.20833C2.08331 5.6558 2.30281 5.12589 2.69351 4.73519C3.08421 4.34449 3.61411 4.125 4.16665 4.125L9.37498 4.125L11.4583 7.25L20.8333 7.25C21.3858 7.25 21.9158 7.46949 22.3065 7.86019C22.6972 8.25089 22.9166 8.7808 22.9166 9.33333L22.9166 20.7917Z",
    fill: "#1D7777",
    stroke: "#1D7777",
    strokeWidth: 2.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_982_5274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(25.5 0.5) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIc);
export default __webpack_public_path__ + "static/media/folder_ic.960a5dd45cfdfba8f96802c8cb0fbd48.svg";
export { ForwardRef as ReactComponent };